import React from 'react';
import { Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';

function ModalShowRejected({ comments, handleClose, show }) {
  return (
    <>
      <ToastContainer autoClose={false} theme="colored" />
      <Modal
        show={show}
        onHide={handleClose}
        className="modal-filters"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="text-center">Causa del rechazo</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <form noValidate>
              <div className="row">
                <div className="">
                  <div className={'form-group'}>
                    <label htmlFor="comments">Observaciones</label>
                    <textarea
                      type="text"
                      className="form-control"
                      name="comments"
                      placeholder="Observaciones"
                      autoComplete="off"
                      value={comments}
                      onChange={() => {}}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ModalShowRejected;
